import { nl } from 'date-fns/locale'

export const PERSON_TYPE_STUDENT = 'STUDENT'
export const PERSON_TYPE_IT_MANAGER = 'ITMANAGER'
export const PERSON_TYPE_ADMIN = 'ADMIN'
export const PERSON_TYPE_TEACHER = 'TEACHER'
export const PERSON_TYPE_MENTOR = 'MENTOR'
export const PERSON_TYPES_MANAGEMENT = [PERSON_TYPE_IT_MANAGER, PERSON_TYPE_ADMIN]
export const PERSON_TYPES_BROWSER_HISTORY = [PERSON_TYPE_IT_MANAGER, PERSON_TYPE_TEACHER, PERSON_TYPE_MENTOR]
export const PERSON_TYPES_TASKS = [PERSON_TYPE_IT_MANAGER, PERSON_TYPE_ADMIN, PERSON_TYPE_TEACHER]

export const RELATION_TYPE_OWNER = 'OWNER'

export const GROUP_TYPE_CLASS = 'CLASS'
export const GROUP_TYPE_EMPLOYEE = 'EMPLOYEE'

export const NODE_TYPE_GROUP = 'GROUP'
export const NODE_TYPE_USER = 'USER'
export const NODE_TYPE_LINK = 'LINK'

export const TASK_STATUS_OPEN = 'OPE'
export const TASK_STATUS_IN_PROGRESS = 'DOI'
export const TASK_STATUS_DONE = 'FIN'

export const TASK_STATUS_MAP = {
  [TASK_STATUS_OPEN]: 'open',
  [TASK_STATUS_IN_PROGRESS]: 'in-progress',
  [TASK_STATUS_DONE]: 'done',
}

export const TASKV2_STATUS_OPEN = 'OPEN'
export const TASKV2_STATUS_IN_PROGRESS = 'IN_PROGRESS'
export const TASKV2_STATUS_DONE = 'DONE'

export const TASKV2_STATUS_MAP = {
  [TASKV2_STATUS_OPEN]: 'open',
  [TASKV2_STATUS_IN_PROGRESS]: 'in_progress',
  [TASKV2_STATUS_DONE]: 'done',
}

export const DATE_FNS_FORMAT_DEFAULT_OPTIONS = { locale: nl }

export const SETTING_BACKGROUND_COLOR = 'backgroundColor'

export const DEFAULT = 'DEFAULT'

export const SNACKBAR_TASK_CREATE = 'create'
export const SNACKBAR_TASK_DELETE = 'delete'
export const SNACKBAR_TASK_EDIT = 'edit'
export const SNACKBAR_TASK_COPY = 'copy'
export const SNACKBAR_TASK_START = 'start'
export const SNACKBAR_TASK_DONE = 'done'
